import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listAffiliatePartners } from "../actions/affiliatepartnerActions";

export default function AffiliatePartner() {
  const dispatch = useDispatch();

  const affiliatePartnerList = useSelector(
    (state) => state.affiliatePartnerList
  );
  const { apartners, loading, error } = affiliatePartnerList;

  useEffect(() => {
    if (apartners == undefined) {
      dispatch(listAffiliatePartners());
    } else if (apartners.length == 0) {
      dispatch(listAffiliatePartners());
    }
  }, [dispatch, apartners]);

  return (
    <>
      {loading ? (
        <option value="0" key="1">
          Loading...
        </option>
      ) : apartners ? (
        apartners.map((countf) => (
          <option key={countf.Id} value={countf.Affiliate_Partner_Id}>
            {countf.Affiliate_Partner}
          </option>
        ))
      ) : (
        <option value="0" key="1">
          {error}
        </option>
      )}
    </>
  );
}
